import React, { useCallback } from 'react';
import { DndContext, Modifier, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import {
  restrictToParentElement,
  restrictToVerticalAxis,
  snapCenterToCursor,
} from '@dnd-kit/modifiers';
import { useDispatch, useSelector } from 'react-redux';
import dropHandlers from './dropHandlers';
import { selectGroupCollection } from '@actions/groups';

const limitModifierToType =
  (modifier: Modifier, dragType: 'contactIDs' | 'group'): Modifier =>
  (args) => {
    if (args.active?.data?.current?.type == dragType) {
      return modifier(args);
    }

    return args.transform;
  };

export default function DragAndDropProvider({ children }) {
  const dispatch = useDispatch();
  const { items: groupsMap } = useSelector(selectGroupCollection);
  const pointerSensor = useSensor(PointerSensor, {
    activationConstraint: {
      // distance cursor needs to travel after pointerdown before we kick off a drag event
      distance: 3,
    },
  });
  const sensors = useSensors(pointerSensor);
  const onDragEnd = useCallback(dropHandlers(dispatch, groupsMap), [groupsMap]);

  return (
    <DndContext
      sensors={sensors}
      onDragEnd={onDragEnd}
      modifiers={[
        limitModifierToType(snapCenterToCursor, 'contactIDs'),
        limitModifierToType(restrictToVerticalAxis, 'group'),
        limitModifierToType(restrictToParentElement, 'group'),
      ]}
    >
      {children}
    </DndContext>
  );
}
